import { BlockOutlined, ChevronRight, SearchRounded } from '@mui/icons-material';
import {
    Alert,
    Avatar,
    Button,
    CardContent,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    FormControlLabel,
    Grid,
    IconButton,
    InputAdornment,
    ListItemAvatar,
    ListItemText,
    Pagination,
    Paper,
    Stack,
    Switch,
    TextField,
} from '@mui/material';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
// import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useFetch } from '../../../hooks/useFecth';
import useDialog from '../../../hooks/useDialog';
import SelectBrandLomadee from './components/SelectBrandLomadee';
import DialogProductDetails from './components/DialogProductDetails';
import DialogOffer from './components/DialogOffer';
import SelectAdvertiser from '../../../components/SelectAdvertiser';
import { stripHtml } from 'string-strip-html';
import useErrors from '../../../hooks/useErrors';
import server from '../../../services/server';
import DatePicker from 'react-multi-date-picker';
import SelectCategoriesParentChild from '../../../components/SelectCategoriesParentChild';
import Address from '../../../components/Address';
import AddImage from '../../../components/AddImage';
import { useFormik } from 'formik';
import PhoneInputMasked from '../../../components/PhoneInputMasked';
import DocumentInputMasked from '../../../components/DocumentInputMasked';
import { enqueueSnackbar } from 'notistack';

import { stripBase64DataUrlPrefix, urlToBase64 } from '../../../services/imageBase64';

function AdvertiserLinkModal({ open, onClose, brand, mutate }) {
    const { enqueueSnackbar, setErrors } = useErrors();
    const [selectedAdvertiserId, setSelectedAdvertiserId] = useState('');

    const { data } = useFetch(
        selectedAdvertiserId ? `advertiser/${selectedAdvertiserId}` : null,
    );

    const { values, handleSubmit, handleChange, setFieldValue, setFieldError, setValues, resetForm, isSubmitting } = useFormik({
        initialValues: {
            name: '',
            businessName: '',
            description: '',
            image: '',
            previewImage: '',
            document: '',
            headOfficeId: '',
            zipcode: '',
            street: '',
            number: '',
            complement: '',
            neighborhood: '',
            city: '',
            state: '',
            country: '',
            phone: '',
            areacode: '',
            latitude: '',
            longitude: '',
            address: '',
            status: true,
            listCategoryId: [],
            responsibleName: '',
            responsibleEmail: '',
            responsiblePhone: '',
            notes: '',
            contractExpiredAt: null,
            email: '',
            approved: true,
            action: 'create'
        },
        onSubmit: async (values, { setSubmitting }) => {
            try {

                setSubmitting(true);

                // Se escolheu um anunciante existente, apenas vincula (atualiza socialSoulId)
                if (values.action === 'update') {
                    console.log('update');
                    await server.put(`advertiser/${selectedAdvertiserId}`, {
                        socialSoulId: brand.id,
                    });

                    enqueueSnackbar('Anunciante vinculado à loja com sucesso.');
                    await mutate();
                    onClose();
                    return;
                }

                // Caso esteja editando um anunciante já existente pelo formulário, garante vínculo no PUT
                // if (Boolean(values.id)) {
                //     const { action, previewImage, ...payload } = values;
                //     await server.put(`advertiser/${values.id}`, { ...payload, socialSoulId: brand.id });
                //     enqueueSnackbar(`Anunciante ${values.name} alterado e vinculado`);
                //     await mutate();
                //     onClose();
                //     return;
                // }
                if (values.action === 'create') {
                    console.log('create');
                      // Senão, cria um novo anunciante vinculado à loja
                const { action, previewImage, ...rest } = values;
                
                const payload = {
                    ...rest,
                    name: rest.name || brand.name,
                    website: rest.website || '',
                    socialSoulId: brand.id,
                };

                const { data } = await server.post('advertiser', payload);
                enqueueSnackbar(`Anunciante ${data?.data?.name || payload.name} criado e vinculado à loja.`);

               
                await mutate();


                }


             
                onClose();
            } catch (error) {
                setErrors(error);
            } finally {
                setSubmitting(false);
            }
        },
    });


    useEffect(() => {
        let cancelled = false;

        if (!open) {
            setSelectedAdvertiserId('');
            resetForm();
            return;
        }

        if (data) {
            setValues(
                {
                    ...data,
                    address: `${data.street}, ${data.neighborhood}, ${data.city}-${data.state}`,
                    listCategoryId: data?.Advertiser_category?.map(i => i.categoryId),
                    action: 'update'
                },
                true,
            );
            return;
        } else {
            resetForm();

            setFieldValue('name', brand?.name || '');
            setFieldValue('website', brand?.site || '');
            setFieldValue('socialSoulId', brand?.id || '');
            setFieldValue('description', brand?.segment || '');

            const logo = brand?.logo;
            if (logo) {
                if (String(logo).startsWith('data:image/')) {
                    setFieldValue('previewImage', String(logo));
                    setFieldValue('image', stripBase64DataUrlPrefix(logo));
                } else if (/^https?:\/\//i.test(String(logo))) {
                    setFieldValue('previewImage', String(logo));
                    urlToBase64(logo)
                        .then(base64 => {
                            if (!cancelled) setFieldValue('image', base64);
                        })
                        .catch(() => {
                            if (!cancelled) setFieldValue('image', '');
                        });
                } else {
                    // pode já vir como base64 sem prefixo
                    setFieldValue('previewImage', `data:image/png;base64,${String(logo)}`);
                    setFieldValue('image', String(logo));
                }
            } else {
                setFieldValue('previewImage', '');
                setFieldValue('image', '');
            }
        }
        return () => {
            cancelled = true;
        };
    }, [open, data, selectedAdvertiserId, brand, setValues, setFieldValue, resetForm]);



    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Vincular anunciante à loja</DialogTitle>
            <DialogContent dividers>
                <Stack spacing={2}>
                    <SelectAdvertiser
                        value={selectedAdvertiserId}
                        name="advertiserId"
                        label="Selecione um anunciante existente"
                        onChange={(_, value) => {
                            setSelectedAdvertiserId(value);
                        }}
                    />

                    <Divider >Dados do anunciante</Divider>
                    {/*
                    <Stack direction="row" alignItems="center" justifyContent="space-between">
                        <DialogTitle>Adicionar/editar anunciante</DialogTitle>
                      <IconButton size="small" onClick={e => openHelp('offer_avaliableQty')}>
                        <Help />
                    </IconButton> 
                        {/* <IconButton size="small" onClick={handleClose} sx={{ marginRight: 2 }}>
                    <Close />
                    </IconButton> 
                    </Stack>*/}
                    <Divider />
                    <DialogContent>
                        <Stack id="advertiser-link-form" gap={2} component="form" onSubmit={handleSubmit}>
                            <AddImage onChange={setFieldValue} name="image" value={values.previewImage || values.image} />
                            <TextField onChange={handleChange} label="Nome do anunciante" name="name" value={values.name} />
                            <TextField onChange={handleChange} label="Razão social" name="businessName" value={values.businessName} />
                            <TextField
                                onChange={event => {
                                    setFieldValue('document', event.target?.value || event);
                                }}
                                label="Documento"
                                name="document"
                                value={values.document}
                                InputProps={{
                                    inputComponent: DocumentInputMasked,
                                }}
                            />

                            <TextField
                                onChange={event => {
                                    setFieldValue('phone', event.target?.value || event);
                                }}
                                label="Telefone"
                                name="phone"
                                value={values.phone || ''}
                                InputProps={{
                                    inputComponent: PhoneInputMasked,
                                }}
                            />

                            <TextField onChange={handleChange} label="Email de contato" name="email" value={values.email} />
                            <TextField onChange={handleChange} label="Website" name="website" value={values.website} />


                            <TextField onChange={handleChange} rows={10} multiline label="Sobre a loja" name="description" value={values.description} />

                            <Address
                                onChange={handleChange}
                                setFieldValue={setFieldValue}
                                name="zipcode"
                                setFieldError={setFieldError}
                                value={values.zipcode}
                                address={values.address}
                            />
                            <Stack direction="row" columnGap={2}>
                                <TextField fullWidth onChange={handleChange} label="Complemento" name="complement" value={values.complement} />
                                <TextField sx={{ width: 150 }} onChange={handleChange} label="Número" name="number" value={values.number} />
                            </Stack>

                            <Stack direction="row" columnGap={2}>
                                <TextField fullWidth onChange={handleChange} label="Latitude" name="latitude" value={values.latitude} />
                                <TextField fullWidth onChange={handleChange} label="Longitude" name="longitude" value={values.longitude} />
                            </Stack>

                            {/* Selecionando categorias pai + filhas + netas */}
                            {Boolean(values.id) && !values.headOfficeId && (
                                <>
                                    <SelectCategoriesParentChild
                                        value={values.listCategoryId}
                                        name="listCategoryId"
                                        onChange={setFieldValue}
                                        label="Selecione as categorias"
                                    />
                                </>
                            )}

                            {Boolean(values.id) && (
                                <>
                                    <Divider>Dados internos</Divider>
                                    <TextField onChange={handleChange} label="Nome do responsável" name="responsibleName" value={values.responsibleName} />
                                    <TextField onChange={handleChange} label="Email do responsável" name="responsibleEmail" value={values.responsibleEmail} />
                                    <TextField
                                        onChange={event => {
                                            setFieldValue('responsiblePhone', event.target?.value || event);
                                        }}
                                        label="Telefone do responsável"
                                        name="responsiblePhone"
                                        value={values.responsiblePhone || ''}
                                        InputProps={{
                                            inputComponent: PhoneInputMasked,
                                        }}
                                    />
                                    <TextField onChange={handleChange} rows={5} multiline label="Observações" name="notes" value={values.notes} />

                                    <DatePicker
                                        label="Data de Expiração do Contrato"
                                        value={values.contractExpiredAt ? new Date(values.contractExpiredAt) : null}
                                        onChange={newValue => setFieldValue('contractExpiredAt', newValue)}
                                        slotProps={{
                                            textField: {
                                                fullWidth: true,
                                            },
                                        }}
                                    />
                                    <FormControlLabel
                                        label="Status anunciante"
                                        control={<Switch checked={values.status} onChange={e => setFieldValue('status', e.target.checked)} />}
                                    />
                                </>
                            )}


                        </Stack>
                    </DialogContent>
                    {/*   <Divider />
                   <DialogActions>
                        {Boolean(values.id) && (
                    <Stack sx={{ marginRight: 'auto' }} spacing={0.5}>
                        <Typography fontSize={12}>Desde: {new Date(values.createdAt).toLocaleString('pt-BR')}</Typography>
                        {values.contractExpiredAt && (
                            <Typography fontSize={12}>Contrato expira em: {new Date(values.contractExpiredAt).toLocaleString('pt-BR')}</Typography>
                        )}
                         
                    </Stack>
                    )} */}
                        {/* {Boolean(values.id) && (
                        <Button variant="outlined" onClick={handleGenerateOwnerUser} disabled={isGeneratingOwner}>
                            {isGeneratingOwner ? 'Gerando...' : 'Gerar usuário owner'}
                        </Button>
                    )}
                            <Button variant="contained" onClick={handleSubmit} disabled={isSubmitting}>
                            Salvar e continuar
                        </Button>
                    </DialogActions> */}


                </Stack>
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={onClose}>
                    Fechar
                </Button>
                <Button variant="contained" color="primary" type="submit" form="advertiser-link-form" disabled={isSubmitting}>
                    Salvar vínculo
                </Button>
            </DialogActions>
        </Dialog>
    );
}

// Products - Catálogo de produtos disponíveis na rede Lomadee
// {
//     "_id": "687a4d8899cf150e8ce71b13",
//     "id": "172715",
//     "organizationId": "3ac8822c-900d-46f3-ae72-67c155a3ba99",
//     "__v": 0,
//     "available": true,
//     "createdAt": "2025-07-18T13:35:03.305Z",
//     "description": "Os rack são móveis essenciais para qualquer casa por conta de sua qualidade multifuncional e design super prático. São móveis extremamente versáteis e ganham uma nova função no décor da sala de estar. No passado servia basicamente como apoio para a televisão, mas hoje em dia é usado para completar a decoração com muito charme e estilo. Os móveis rústicos de madeira maciça estão em alta e vem decorando casas, chalés e fazendas que buscam exaltar uma moda passada, lembrando os móveis antigos, agregando luxo e conforto à decoração. A qualidade do produto está em toda sua estrutura, pois é produzida com madeira maciça proveniente de reflorestamento, os móveis ficam ainda mais resistentes e com uma maior durabilidade.<br/><br/>Material: <br/>Madeira Maciça <br/> <br/>Medidas: <br/>Altura - 74cm <br/>Largura - 1,60m <br/>Largura Aberto - 3,15m<br/>Profundidade - 39cm <br/>Suporta até 40Kg <br/><br/>Limpar com pano levemente umedecido, seguido de pano seco. Não utilizar produtos químicos ou abrasivos.<br/><br/>Garantia do fornecedor de 90 dias contra defeitos de fabricação.<br/><br/>Verifique o tamanho de elevadores e portas para transporte do produto. A entrega será feita até a portaria do condomínio ou prédio.<br/><br/>Importante: Não oferecemos serviços de montagem e/ou instalação. Todos os produtos são embalados com total segurança para garantir que cheguem em perfeitas condições. A entrega será feita até a portaria do condomínio ou prédio, sendo de responsabilidade do cliente o transporte até o local desejado, como escadas ou andares superiores.",
//     "images": [
//         {
//             "url": "https://openbox.vteximg.com.br/arquivos/ids/244404/172715_Rack-Retratil-Rustico-em-Madeira-Macica-160m_01.jpg?v=638870880910900000"
//         },
//         {
//             "url": "https://openbox.vteximg.com.br/arquivos/ids/244405/172715_Rack-Retratil-Rustico-em-Madeira-Macica-160m_03.jpg?v=638870880911070000"
//         },
//         {
//             "url": "https://openbox.vteximg.com.br/arquivos/ids/244406/172715_Rack-Retratil-Rustico-em-Madeira-Macica-160m_02.jpg?v=638870880911070000"
//         },
//         {
//             "url": "https://openbox.vteximg.com.br/arquivos/ids/244407/172715_Rack-Retratil-Rustico-em-Madeira-Macica-160m_08.jpg?v=638870880911230000"
//         },
//         {
//             "url": "https://openbox.vteximg.com.br/arquivos/ids/244408/172715_Rack-Retratil-Rustico-em-Madeira-Macica-160m_09.jpg?v=638870880911230000"
//         }
//     ],
//     "metadata": [],
//     "name": "Rack Retrátil Rustico em Madeira Maciça com 6 Gavetas 1,60m",
//     "options": [
//         {
//             "id": "172715",
//             "ean": "9000001727150",
//             "name": "Rack Retrátil Rustico em Madeira Maciça com 6 Gavetas 1,60m",
//             "images": [
//                 {
//                     "url": "https://openbox.vteximg.com.br/arquivos/ids/244404/172715_Rack-Retratil-Rustico-em-Madeira-Macica-160m_01.jpg?v=638870880910900000"
//                 },
//                 {
//                     "url": "https://openbox.vteximg.com.br/arquivos/ids/244405/172715_Rack-Retratil-Rustico-em-Madeira-Macica-160m_03.jpg?v=638870880911070000"
//                 },
//                 {
//                     "url": "https://openbox.vteximg.com.br/arquivos/ids/244406/172715_Rack-Retratil-Rustico-em-Madeira-Macica-160m_02.jpg?v=638870880911070000"
//                 },
//                 {
//                     "url": "https://openbox.vteximg.com.br/arquivos/ids/244407/172715_Rack-Retratil-Rustico-em-Madeira-Macica-160m_08.jpg?v=638870880911230000"
//                 },
//                 {
//                     "url": "https://openbox.vteximg.com.br/arquivos/ids/244408/172715_Rack-Retratil-Rustico-em-Madeira-Macica-160m_09.jpg?v=638870880911230000"
//                 }
//             ],
//             "available": true,
//             "categories": [],
//             "pricing": [
//                 {
//                     "listPrice": 1999.99,
//                     "price": 1999.99,
//                     "metadata": []
//                 }
//             ],
//             "brands": [],
//             "stocks": [
//                 {
//                     "value": 10,
//                     "metadata": []
//                 }
//             ],
//             "metadata": [],
//             "seller": "Elaza Comercial Varejista de Eletrodomésticos Eireli"
//         }
//     ],
//     "updatedAt": "2025-09-10T19:01:13.530Z",
//     "url": "https://www.openbox2.com.br/rack-1-60x0-40x0-75-retratil-rustico-6gav-madeira-172715/p"
// }
export default function ProductsSocialSoul() {
    const [searchParams, setParams] = useSearchParams();

    const [brand, setBrand] = useState();
    const [search, setSearch] = useState(searchParams.get('search') || '');
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [offerData, setOfferData] = useState(null);
    const [openAdvertiserModal, setOpenAdvertiserModal] = useState(false);
    const [isSynced, setIsSynced] = useState(false);

    const { handleOpen: handleOpenProductDetails } = useDialog('product-details');
    const { handleOpen: handleOpenOffer } = useDialog('offer');

    const { data, mutate } = useFetch('brokers/lomadee/products', {
        params: {
            ...Object.fromEntries(searchParams),
            ...(brand?.id && { organizationIds: brand.id }),
        },
    });

    const { data: advertiserBrandData, isFetching: isFetchingAdvertiserBrand, mutate: mutateAdvertiserBrand } = useFetch(
        brand?.id ? `advertiser/external/${brand.id}` : null,
    );


    // Calcular cashback baseado na comissão da marca
    const calculateCashback = (price, commission) => {
        if (!commission || !price) return 0;

        // FIXME: Alguns brands retornam commission.type undefined
        // Temporariamente tratando undefined como FIXED
        // TODO: Revisar com a Lomadee qual é a estrutura correta quando type for undefined
        const commissionType = commission.type || 'FIXED';

        if (commissionType === 'PERCENTAGE') {
            return (price * commission.value) / 100;
        } else if (commissionType === 'FIXED' || !commission.type) {
            return commission.value;
        }

        return 0;
    };

    const handlePage = (event, page) => {
        setParams(prevParams => {
            const newParams = new URLSearchParams(prevParams);
            newParams.set('page', page);
            return newParams;
        });
    };

    const handleSearch = () => {
        setParams(prevParams => {
            const newParams = new URLSearchParams(prevParams);
            if (search) {
                newParams.set('search', search);
            } else {
                newParams.delete('search');
            }
            newParams.set('page', 1);
            return newParams;
        });
    };

    const formatPrice = price => {
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        }).format(price);
    };

    const handleOpenProduct = (product, isSynced) => {
       
        setSelectedProduct(product);
        setIsSynced(isSynced);
        handleOpenProductDetails();
    };

    const handleCreateOffer = (data) => {
        if(!advertiserBrandData) { 
            enqueueSnackbar('Cadastre ou vincule o anunciante.', { variant: 'error' });
            return;
        }
        //limpar html tags da descrição
        setOfferData({ ...data, product: { ...data.product, description: data.product.description ? stripHtml(data.product.description).result : data.product.name } });
        handleOpenOffer();
    };

    // Pegar a primeira opção e primeiro preço para exibir na lista
    const getFirstPrice = (product) => {
        return product?.options?.[0]?.pricing?.[0]?.price || 0;
    };

    const getFirstListPrice = (product) => {
        return product?.options?.[0]?.pricing?.[0]?.listPrice || 0;
    };

    // Contar total de opções e variações de preço
    const getTotalOptions = (product) => {
        return product?.options?.length || 0;
    };

    const getTotalPricings = (product) => {
        return product?.options?.reduce((total, option) => total + (option.pricing?.length || 0), 0) || 0;
    };



    return (
        <Container maxWidth="xl">
            <Stack pb={2}>
                <Typography variant="h2">Produtos Lomadee</Typography>
                <Typography variant="body2" color="text.secondary">
                    Catálogo de produtos disponíveis na rede Lomadee
                </Typography>
            </Stack>

            <Card>
                <CardContent>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} md={6}>
                            <SelectBrandLomadee
                                value={brand?.id || ''}
                                name="brandId"
                                label="Filtrar por marca"
                                onChange={selectedBrand => {
                                    setBrand(selectedBrand);
                                    setParams(prevParams => {
                                        const newParams = new URLSearchParams(prevParams);
                                        if (selectedBrand?.id) {
                                            newParams.set('organizationIds', selectedBrand.id);
                                        } else {
                                            newParams.delete('organizationIds');
                                        }
                                        newParams.set('page', 1);
                                        return newParams;
                                    });
                                }}
                            />
                        </Grid>



                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                placeholder="Buscar produtos..."
                                value={search}
                                onChange={e => setSearch(e.target.value)}
                                onKeyPress={e => e.key === 'Enter' && handleSearch()}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton onClick={handleSearch}>
                                                <SearchRounded />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Grid>
                        {brand && !isFetchingAdvertiserBrand && !advertiserBrandData && (
                            <Grid item xs={12}>
                                <Alert severity="warning" variant="outlined" sx={{ p: 2 }}>
                                    <Stack spacing={1}>
                                        <Typography variant="subtitle2">
                                            Loja sem anunciante vinculado
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            Para cadastrar ofertas desta loja, é necessário vincular um anunciante local que receberá as
                                            vendas e comissões.
                                        </Typography>
                                        <Stack direction="row" justifyContent="flex-end">
                                            <Button
                                                variant="contained"
                                                color="warning"
                                                size="small"
                                                onClick={() => setOpenAdvertiserModal(true)}
                                            >
                                                Vincular anunciante
                                            </Button>
                                        </Stack>
                                    </Stack>
                                </Alert>
                            </Grid>
                        )}

                        {brand?.commission && (
                            <Grid item xs={12}>
                                <Paper variant="outlined" sx={{ p: 2, bgcolor: 'success.lighter' }}>
                                    <Typography variant="subtitle2" color="success.dark" gutterBottom>
                                        💰 Comissão da Marca: {brand.name}
                                    </Typography>
                                    <Stack direction="row" spacing={2} flexWrap="wrap" alignItems="center">
                                        <Chip
                                            size="small"
                                            label={
                                                brand.commission.type === 'PERCENTAGE'
                                                    ? `${brand.commission.value}% do valor do produto`
                                                    : `R$ ${brand.commission.value.toFixed(2)} fixo${!brand.commission.type ? ' (tipo indefinido)' : ''}`
                                            }
                                            color="success"
                                        />

                                        {brand.commission.description && (
                                            <Typography variant="caption" color="text.secondary">
                                                {brand.commission.description}
                                            </Typography>
                                        )}
                                        {!brand.commission.type && (
                                            <Chip size="small" label="⚠️ FIXME: Revisar tipo" color="warning" variant="outlined" />
                                        )}
                                    </Stack>
                                </Paper>
                            </Grid>
                        )}
                    </Grid>
                </CardContent>
                <Divider />

                <List size="md" sx={{ gap: 1 }}>
                    <>
                        {data?.meta?.total === 0 && (
                            <Paper sx={{ p: 4, border: 0 }}>
                                <Stack direction="row" justifyContent="center" gap={1}>
                                    <Typography>Nenhum produto encontrado.</Typography>
                                    <BlockOutlined />
                                </Stack>
                            </Paper>
                        )}

                        {data?.products?.map(item => {
                            const productPrice = getFirstPrice(item);
                            const productListPrice = getFirstListPrice(item);
                            const cashbackValue = brand?.commission ? calculateCashback(productPrice, brand.commission) : 0;
                            const totalOptions = getTotalOptions(item);
                            const totalPricings = getTotalPricings(item);
                            const seller = item.options.find(option => option.seller).seller;
                            const syncedOffers = (data?.syncedOffers || []).map(Number);

                            const isSynced = syncedOffers.includes(Number(item.id));
                      
                            return (
                                <React.Fragment key={`product_item_${item.id}`}>
                                    <ListItem
                                        // sx={{ cursor: 'pointer', '&:hover': { bgcolor: 'action.hover' } }}

                                        sx={{
                                            cursor: 'pointer',
                                            bgcolor: isSynced ? 'rgba(56, 142, 60, 0.2)' : 'transparent', // verde bem suave
                                        }}
                                        onClick={() => handleOpenProduct(item, isSynced)}
                                        secondaryAction={
                                            <IconButton>
                                                <ChevronRight />
                                            </IconButton>
                                        }
                                    >

                                        <ListItemAvatar sx={{ mr: 2 }}>
                                            
                                            <Avatar


                                                src={item.images[0].url}
                                                variant="rounded"
                                                sx={{ border: '1px solid #eee', objectFit: 'cover', width: 60, height: 60 }}
                                            />
                                        </ListItemAvatar>
                                        <ListItemText
                                            primary={item.name}
                                            primaryTypographyProps={{ variant: 'title-sm' }}
                                            secondary={
                                                <Stack spacing={0.5} pt={0.5}>
                                                    {/* {item.description && (
                                                        <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }} gutterBottom>
                                                            {item.description}
                                                        </Typography>
                                                    )} */}
                                                    <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" sx={{ mb: 0.5 }}>
                                                        {productPrice > 0 && (
                                                            <Chip size="small" label={formatPrice(productPrice)} color="primary" variant="filled" />
                                                        )}
                                                        {productListPrice > 0 && productListPrice > productPrice && (
                                                            <Typography
                                                                variant="caption"
                                                                color="text.secondary"
                                                                sx={{ textDecoration: 'line-through' }}
                                                            >
                                                                {formatPrice(productListPrice)}
                                                            </Typography>
                                                        )}
                                                        {totalOptions > 1 && (
                                                            <Chip size="small" label={`${totalOptions} opções`} color="info" variant="outlined" />
                                                        )}
                                                        {totalPricings > 1 && (
                                                            <Chip size="small" label={`${totalPricings} preços`} color="secondary" variant="outlined" />
                                                        )}



                                                        {cashbackValue > 0 && (
                                                            <Chip
                                                                size="small"
                                                                label={`💰 Comissão: ${formatPrice(cashbackValue)}`}
                                                                color="success"
                                                                variant="outlined"
                                                            />
                                                        )}

                                                        {item.available && <Chip size="small" label="Disponível" color="success" variant="outlined" />}
                                                        {!item.available && <Chip size="small" label="Indisponível" color="error" variant="outlined" />}

                                                        <Chip size="small" label={seller} color="primary" variant="outlined" />
                                                        {isSynced && (
                                                            <Chip size="small" label="Oferta cadastrada" color="success" variant="outlined" />
                                                        )}
                                                    </Stack>
                                                    <Typography variant="caption" color="text.secondary">
                                                        Clique para ver todas as opções e preços
                                                    </Typography>
                                                </Stack>
                                            }
                                        />
                                    </ListItem>
                                    <Divider />
                                </React.Fragment>
                            );
                        })}
                    </>
                </List>

                {data?.meta?.total > 0 && (
                    <Stack direction="row" py={2} justifyContent="center">
                        <Pagination page={data?.meta?.page || 1} count={data?.meta?.totalPages || 1} onChange={handlePage} />
                    </Stack>
                )}
            </Card>

            <DialogProductDetails product={selectedProduct} brand={brand} onCreateOffer={handleCreateOffer}   isSynced={isSynced} />
            <DialogOffer mutate={mutate} productData={offerData} />
            <AdvertiserLinkModal open={openAdvertiserModal} onClose={() => setOpenAdvertiserModal(false)} brand={brand} mutate={mutateAdvertiserBrand}  />
        </Container>
    );
}

